/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Capture_Create_Student_QInputs */

const en_capture_create_student_q = /** @type {(inputs: Capture_Create_Student_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create student?`)
};

const he_capture_create_student_q = /** @type {(inputs: Capture_Create_Student_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ליצור תלמיד?`)
};

/**
* | output |
* | --- |
* | "Create student?" |
*
* @param {Capture_Create_Student_QInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const capture_create_student_q = /** @type {((inputs?: Capture_Create_Student_QInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Capture_Create_Student_QInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_capture_create_student_q(inputs)
	return he_capture_create_student_q(inputs)
});